// START: GitHub Copilot Generated Code
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import config from "../../config/config";
import { KEY_sessionLanguage } from "../../constants";
import { isSupportedLanguage } from "../../services/languageUtils";
import { LogVerbose } from "../../services/logUtils";
import { readFromStorage, writeToStorage } from "../../services/storageServies";
import { LanguageState, State } from "../state";

// Initialize with default language from config
// Redux store is now the single source of truth for language
const initialState: LanguageState = {
  language: readFromStorage<string>(KEY_sessionLanguage, 'SessionStorage') || config.languageConfig.defaultLanguageName,
};
// END: GitHub Copilot Generated Code

// START: GitHub Copilot Generated Code
export const languageSlice = createSlice({
  name: 'language',
  initialState: initialState,
  reducers: {
    /**
     * Sets the application language with validation
     * OWASP Security: Validates language against supported languages list
     * If language is invalid or unsupported, current language is kept
     * 
     * @param state - Current language state
     * @param action - Payload containing the language code to set
     */
    setLanguage: (state: LanguageState, action: PayloadAction<string | undefined>) => {
      const newLanguage = action.payload;

      // Validate language is provided
      if (!newLanguage) {
        console.warn('Language is undefined, keeping current language');
        return;
      }

      // OWASP Security: Validate language is supported
      if (!isSupportedLanguage(newLanguage)) {
        console.error(`Language ${newLanguage} is not supported. Keeping current language: ${state.language}`);
        return;
      }

      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      // LogVerbose(`Redux: Switching LanguageState from ${state.language} to ${newLanguage}`);
      state.language = newLanguage;
      writeToStorage(KEY_sessionLanguage, newLanguage, 'SessionStorage');
      LogVerbose(`Redux: Switched LanguageState to: ${state.language}`);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export const selectLanguage = (state: State): string => state.language.language;
export default languageSlice.reducer;
// END: GitHub Copilot Generated Code